import { __constants } from "../constants"
import axios from "axios"
const BASE_URL = process.env.REACT_APP_SERVER_URL

// Get all FAQs or a specific FAQ by ID, with optional type filter
export const getFAQsController = async (faqId = null, type = null) => {
  try {
    let url = `${BASE_URL}/v1/faq`
    const params = []

    if (faqId) {
      params.push(`faqId=${faqId}`)
    }

    if (type) {
      params.push(`type=${type}`)
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`
    }

    const response = await axios.get(url,
          {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
      },
    }
    )
    return response
  } catch (error) {
    console.error("Error in getFAQsController:", error)
    return error.response
  }
}

// Add or edit a FAQ with type field
export const addEditFAQController = async (data) => {
  try {
    const response = await axios.put(`${BASE_URL}/v1/admin/faq`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
      },
    })
    return response
  } catch (error) {
    console.error("Error in addEditFAQController:", error)
    return error.response
  }
}

// Remove a FAQ
export const removeFAQController = async (faqId) => {
  try {
    const response = await axios.delete(`${BASE_URL}/v1/admin/faq?faqId=${faqId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
      },
    })
    return response
  } catch (error) {
    console.error("Error in removeFAQController:", error)
    return error.response
  }
}
